import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@b2b/ui-components";
import { MessageCircle, Heart, Mail } from "lucide-react";
import { authService } from "@b2b/services";

export function Welcome() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState<string>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        const meResponse = await authService.getMe();
        if (meResponse?.user) {
          const user = meResponse.user as {
            firstName?: string;
            lastName?: string;
            email?: string;
          };
          const name =
            user.firstName && user.lastName
              ? `${user.firstName} ${user.lastName}`
              : user.firstName ||
                (user.email ? user.email.split("@")[0] : "") ||
                "User";
          setUserName(name);
        } else {
          setUserName("User");
        }
      } catch {
        setUserName("User");
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  const handleChatClick = () => {
    const fullUrl = `${window.location.origin}/chat`;
    window.open(fullUrl, "_blank", "noopener,noreferrer");
  };

  if (loading) {
    return (
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="h-8 w-64 bg-gray-200 rounded animate-pulse mb-2" />
          <div className="h-4 w-96 bg-gray-200 rounded animate-pulse" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900 tracking-tight">
          Welcome back, {userName}
        </h1>
        <p className="text-sm text-gray-500 mt-0.5">
          Your saved products, enquiries, and messages in one place
        </p>
      </div>
      <div className="flex flex-wrap gap-2 w-full sm:w-auto">
        <Button
          variant="outline"
          onClick={() => navigate("/buyer/favorites")}
          className="flex items-center gap-2"
        >
          <Heart className="h-4 w-4" />
          Favorites
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate("/buyer/enquiries")}
          className="flex items-center gap-2"
        >
          <Mail className="h-4 w-4" />
          My Enquiries
        </Button>
        <Button
          variant="outline"
          onClick={handleChatClick}
          className="flex items-center gap-2"
        >
          <MessageCircle className="h-4 w-4" />
          Chat
        </Button>
      </div>
    </div>
  );
}
